<div style="margin-bottom: 4em">
  <div class="container mt-4">
    <!-- Referral Header Section -->
    <div class="referalmain displaySpace mt-5">
      <div>
        <h2 style="
            color: #fff;
            font-weight: 700;
            font-size: 32px;
            line-height: 36px;
          ">
          Join the Referral Program Today!
        </h2>
        <div class="d-flex justify-start-center" style="gap: 10px">
          <p style="color: #ffc83b; font-weight: 900; font-size: 18px">
            Share your unique referral ID
          </p>
          <a class="social-button facebook" (click)="refferNow()" style="cursor: pointer">
            <i class="fa fa-share-alt" aria-hidden="true"></i></a>
        </div>

        <p class="pt-4" style="color: #fff">Personal referral URL</p>
        <input type="text" placeholder="Your personal referral URL" [value]="referUrl || ''" readonly
          class="form-control form-control-sm" />

        <button class="mt-3 btn btn-outline-success referal-button back-button newBty" (click)="copyText(referUrl)"
          type="submit">
          Copy Link
        </button>
      </div>

      <img src="assets/images/referal.png" alt="Referal" class="referlgift" />
    </div>

    <!-- Referral Steps Section -->
    <h2 class="mt-5 text-left" style="color: #000; font-weight: 700; font-size: 32px; line-height: 36px">
      How does the Referral Program work?
    </h2>

    <div class="row mt-4">
      <!-- Step 1 -->
      <div class="col-12 col-sm-6 col-md-4 mb-4">
        <div class="referal-stepbox h-100 p-3 bg-light rounded shadow-sm">
          <p style="font-weight: 600; font-size: 15px">Invite Friends</p>
          <p>
            Share your unique referral link with friends via social media,
            email, or WhatsApp.
          </p>
          <p style="font-weight: 600; color: #c8102e">Step 1</p>
        </div>
      </div>

      <!-- Step 2 -->
      <div class="col-12 col-sm-6 col-md-4 mb-4">
        <div class="referal-stepbox h-100 p-3 bg-light rounded shadow-sm">
          <p style="font-weight: 600; font-size: 15px">They Shop</p>
          <p>
            Your friend makes their first purchase using your referral link.
          </p>
          <p style="font-weight: 600; color: #c8102e">Step 2</p>
        </div>
      </div>

      <!-- Step 3 -->
      <div class="col-12 col-sm-6 col-md-4 mb-4">
        <div class="referal-stepbox h-100 p-3 bg-light rounded shadow-sm">
          <p style="font-weight: 600; font-size: 15px">You Earn Rewards</p>
          <p>
            You earn store credit or a discount on your next order once your
            friend completes their purchase.
          </p>
          <p style="font-weight: 600; color: #c8102e">Step 3</p>
        </div>
      </div>
    </div>

    <!-- Table Section Added -->
    <div class="exobeText mt-4 mb-2">
      <h2 class="text-left" style="
          color: #000;
          font-weight: 700;
          font-size: 32px;
          line-height: 36px;
          margin-bottom: 0px !important;
          margin-top: 0px !important;
        ">
        eXobe token transactions.
      </h2>
      <select (change)="currentPage = 1; listApi($event.target.value)" class="form-control referalSelect">
        <option value="">All</option>
        <option value="REFERAL">Referal</option>
        <option value="BONUS">Bonus</option>
        <option value="REDEEM">Redeem</option>
      </select>
    </div>

    <div class="row mt-4">
      <!-- Step 1 -->
      <div class="col-12 col-sm-6 col-md-4 mb-4">
        <div class="referal-stepbox referalshadow h-100 p-3 bg-light rounded shadow-sm">
          <div class="d-flex" style="align-items: start; justify-content: flex-start; gap: 13px">
            <img src="/assets/images/balance.png" alt="Balance" style="width: 40px; height: 40px" />
            <div>
              <p style="font-weight: 600; font-size: 15px; margin-bottom: 5px">
                Available Balance
              </p>
              <h1 style="font-weight: 600">
                {{ profileData?.cryptoBalance?.available || 0 }} eXobe
              </h1>
              <a data-toggle="modal" data-target="#withdrawModal" style="
                  cursor: pointer;
                  position: absolute;
                  top: 4px;
                  right: 8px;
                  color: #c8102e;
                  font-weight: 800;
                  font-size: 13px;
                " class="blink-animation" *ngIf="
                  profileData?.userType == 'SERVICE_PROVIDER' ||
                  profileData?.userType == 'PICKUP_PARTNER' ||
                  profileData?.userType == 'DELIVERY_PARTNER' ||
                  profileData?.userType == 'FIELD_ENTITY'
                ">Withdraw</a>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 2 -->
      <div class="col-12 col-sm-6 col-md-4 mb-4">
        <div class="referal-stepbox referalshadow h-100 p-3 bg-light rounded shadow-sm">
          <div class="d-flex" style="align-items: start; justify-content: flex-start; gap: 13px">
            <img src="/assets/images/earned.png" alt="Balance" style="width: 40px; height: 40px" />
            <div>
              <p style="font-weight: 600; font-size: 15px; margin-bottom: 5px">
                Total Earned
              </p>
              <h1 style="font-weight: 600">
                {{ profileData?.cryptoBalance?.earned || 0 }} eXobe
              </h1>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 3 -->
      <div class="col-12 col-sm-6 col-md-4 mb-4">
        <div class="referal-stepbox referalshadow h-100 p-3 bg-light rounded shadow-sm">
          <div class="d-flex" style="align-items: start; justify-content: flex-start; gap: 13px">
            <img src="/assets/images/tier.png" alt="Balance" style="width: 40px; height: 40px" />
            <div>
              <p style="font-weight: 600; font-size: 15px; margin-bottom: 5px">
                Tier
              </p>
              <h1 style="font-weight: 600">
                {{ profileData?.cryptoBalance?.tier || "Bronze" }}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3" style="margin-top: 24px !important">
      <div class="table-responsive">
        <table class="table table-hover table-striped">
          <thead>
            <tr style="background: #c8102e">
              <th style="color: #fff">S.No</th>
              <th style="color: #fff">Amount</th>
              <th style="color: #fff">Order Id</th>
              <!-- <th style="color: #fff">Transaction Hash</th> -->
              <th style="color: #fff">Date & Time</th>
              <th style="color: #fff">Type</th>
              <th style="color: #fff">Transaction Status</th>
              <th style="color: #fff">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="
                let item of listData
                  | paginate
                    : {
                        itemsPerPage: itemPerPage,
                        currentPage: currentPage,
                        totalItems: totalItems
                      };
                let i = index
              ">
              <td>{{ 10 * (currentPage - 1) + i + 1 }}</td>
              <td>{{ item?.amount }} eXobe</td>
              <td>{{ item?.orderId?.orderId }}</td>
              <!-- <td>
                {{ shortenAddress(item?.transactionHash) || '--' }}
                <i *ngIf="item?.transactionHash" (click)="copyText(item?.transactionHash)" class="fa fa-clone"></i>
              </td> -->
              <td>{{ item?.createdAt | date : "medium" || "--" }}</td>
              <td>{{ item?.transactionType }}</td>
              <td>{{ item?.transactionStatus }}</td>
              <td>{{ item?.status }}</td>
            </tr>
            <tr *ngIf="!listData.length">
              <td class="table-no-record text-center" colspan="7">
                <div style="
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                  ">
                  <img src="assets/images/notfound.png" alt="No Data Found" class="notfound-img"
                    style="width: auto; max-width: 100px" />No Data Found
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="custom-pagination mt-2 text-align-end" *ngIf="totalItems > 10">
          <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="shareCodeModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content" style="margin-top: 230px">
      <div class="modal-header" style="background: #c8102e; justify-content: center">
        <h1 class="modal-title" id="exampleModalLabel" style="
            color: #fff;
            text-align: center;
            margin-bottom: 0px;
            font-size: 25px;
            font-weight: 600;
          ">
          Share Your Invitation Link
        </h1>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          style="position: absolute; right: 10px">
          <span aria-hidden="true" style="color: #fff">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="background: #c8102e">
        <h5 style="color: #fff; font-size: 15px; text-align: center">
          Share on Social Media
        </h5>
        <div class="d-flex justify-content-center mt-3 mb-3" style="gap: 13px">
          <a href="#" class="social-button whatsapp" title="WhatsApp">
            <i class="fa fa-whatsapp"></i>
          </a>
          <a href="#" class="social-button instagram" title="Instagram">
            <i class="fa fa-instagram"></i>
          </a>
          <a href="#" class="social-button linkedin" title="LinkedIn">
            <i class="fa fa-envelope"></i>
          </a>
          <a href="#" class="social-button facebook" title="Facebook">
            <i class="fa fa-facebook-f"></i>
          </a>
          <a href="#" class="social-button facebook" title="Facebook">
            <i class="fa fa-clone"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="withdrawModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content" style="margin-top: 230px">
      <div class="modal-header" style="background: #c8102e; justify-content: center">
        <h1 class="modal-title" id="exampleModalLabel" style="
            color: #fff;
            text-align: center;
            margin-bottom: 0px;
            font-size: 25px;
            font-weight: 600;
          ">
          Withdraw Token
        </h1>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          style="position: absolute; right: 10px">
          <span aria-hidden="true" style="color: #fff">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="background: #c8102e; padding-top: 0px">
        <!-- <h5 style="color: #fff; font-size: 15px; text-align: center">
          Withdraw Token
        </h5> -->
        <form [formGroup]="withdrawForm">
          <div class="mt-3 mb-3" style="gap: 13px">
            <label for="toWallet" style="color: #fff">Wallet address<span class="redis">*</span></label>
            <div class="input-control mt-1">
              <input type="text" class="form-control" placeholder="Enter wallet address" type="text"
                formControlName="toWallet" placeholder="Enter wallet address" (keypress)="preventSpace($event)"
                id="username" />
              <div class="for-validation mb-4">
                <div class="for-validation text-danger" *ngIf="
                    withdrawForm.get('toWallet')?.hasError('required') &&
                    isSubmitted
                  ">
                  *Please enter you wallet address.
                </div>
                <div class="for-validation text-danger" *ngIf="
                    withdrawForm.get('toWallet')?.hasError('pattern') &&
                    isSubmitted
                  ">
                  *Invalid wallet address.
                </div>
              </div>
            </div>
            <label for="toWallet" style="color: #fff">Amount<span class="redis">*</span></label>
            <div class="input-control mt-1">
              <input type="text" class="form-control" placeholder="Enter amount" type="text" formControlName="amount"
                placeholder="Enter amount" (keypress)="preventSpace($event)" id="username" />
              <div class="for-validation mb-4">
                <div class="for-validation text-danger" *ngIf="
                    withdrawForm.get('amount')?.hasError('required') &&
                    isSubmitted
                  ">
                  *Please enter amount to withdraw.
                </div>
                <div class="for-validation text-danger" *ngIf="
                    withdrawForm.get('amount')?.hasError('pattern') &&
                    isSubmitted
                  ">
                  *Invalid amount.
                </div>
              </div>
            </div>
            <button class="for-login btn text-white btn-block btn-primary" *ngIf="!loading" (click)="withdrawToken()"
              type="submit" style="
                background: #ffc83b;
                color: #000 !important;
                border: none !important;
                font-weight: 600;
              ">
              Submit
            </button>
            <button class="for-login btn text-white btn-block btn-primary" *ngIf="loading" type="submit" style="
                background: #ffc83b;
                color: #000 !important;
                border: none !important;
                font-weight: 600;
              ">
              Loading...
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>